// generated from 173 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const lastSentSpecificSmsInboundKeywordFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("last_sent_specific_sms_inbound_keyword_filter"),
  comparison_key: z.enum([
    "3", // 110 (63.58%)
    "4", // 53 (30.64%)
    "6", // 7 (4.05%)
    "5", // 3 (1.73%)
  ]),
  display_name: z.object({
    id: common.objectId,
    pre_filter_shell_value: z.object({
      id: common.objectId,
      value: z.string(),
    }),
    value: z.string(),
  }),
  // undefined: 142 (82.08%), defined 31 (17.92%)
  raw_value: z
    .union([
      // number samples: 6 (19.35%)
      // integer: 5 (83.33%)
      // avg: 56.34, min: 0, max: 168
      z.number().min(0),
      // string samples: 25 (80.65%)
      common.date,
    ])
    .optional(),
  value: z.union([
    // number samples: 60 (34.68%)
    // integer: 12 (20.00%)
    // avg: 17.66, min: 0, max: 700
    z.number().min(0),
    // string samples: 113 (65.32%)
    common.date,
  ]),
  varies_by_app_group: z.literal(true),
});
